// extracted by mini-css-extract-plugin
module.exports = {"input":"NumberInput_input__lpqXg","disabledWithTooltip":"NumberInput_disabledWithTooltip__X_fV_","inputLabel":"NumberInput_inputLabel__jX6Fx"};